// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3oh8t","right":"Footer_right__1wUfs","buttons":"Footer_buttons__4PW4e"};